import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';

export const supportedLanguages = ['en', 'ru'] as const;
export type Language = (typeof supportedLanguages)[number];

const STORAGE_KEY = 'horizon.language';

function detectLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'ru') return stored;
  } catch {
    /* хранилище недоступно — определяем по браузеру */
  }
  return navigator.language?.toLowerCase().startsWith('ru') ? 'ru' : 'en';
}

export function setLanguage(language: Language): Promise<unknown> {
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    /* язык действует до перезагрузки */
  }
  document.documentElement.lang = language;
  return i18n.changeLanguage(language);
}

/**
 * Формы множественного числа берутся из Intl.PluralRules, то есть из категорий
 * CLDR. Для русского это one / few / many / other — ручные пары
 * «1 задача / N задач» запрещены (ROADMAP, сквозные требования).
 */
i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ru: { translation: ru } },
  lng: detectLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

document.documentElement.lang = i18n.language;

export default i18n;
